import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBAspect } from '@shared/components/aspect';
import { MBImage } from '@shared/components/image';

export function MBGIFError() {
  return (
    <View fill center>
      <MBText>Oops, could not load GIFs</MBText>
      <MBAspect ratio={1} padding={2.5} style={{ width: '60%' }}>
        <MBImage
          fill
          resizeMode="contain"
          source={{ uri: 'https://i.giphy.com/media/nVTa8D8zJUc2A/giphy.gif' }}
        />
      </MBAspect>
    </View>
  );
}
